import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { useConfigurationAttributeDescription, } from "@plansoft-configuration-renderer/framework";
import { MarkdownOrText } from "../Common/MarkdownOrText";
export function AttributeDescription(props) {
    const labelText = useConfigurationAttributeDescription();
    const { textMode = "plaintext" } = props;
    return (_jsx(Box, { children: _jsx(MarkdownOrText, { text: labelText, textMode: textMode }) }));
}
//# sourceMappingURL=AttributeDescription.js.map